import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import {
  fetchCollectionKeywordDetail,
  fetchCollectionKeywords,
  fetchCollectionKeywordSummaries,
} from '@/api/collectionKeywords/api'
import type {
  CollectionKeywordDetail,
  CollectionKeywordRow,
  CollectionKeywordSummary,
} from '@/api/collectionKeywords/types'

export function useCollectionKeywordSummaries(): UseQueryResult<
  readonly CollectionKeywordSummary[]
> {
  return useQuery({
    queryKey: ['collection-keyword-summaries'],
    queryFn: ({ signal }) => fetchCollectionKeywordSummaries(signal),
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  })
}

export function useCollectionKeywords(
  collectionIds: readonly number[],
): UseQueryResult<readonly CollectionKeywordRow[]> {
  return useQuery({
    queryKey: ['collection-keywords', collectionIds],
    queryFn: ({ signal }) => fetchCollectionKeywords(collectionIds, signal),
    enabled: collectionIds.length > 0,
    placeholderData: [],
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  })
}

export function useCollectionKeywordDetail(
  collectionId: number,
): UseQueryResult<CollectionKeywordDetail | null> {
  return useQuery({
    queryKey: ['collection-keyword-detail', collectionId],
    queryFn: ({ signal }) => fetchCollectionKeywordDetail(collectionId, signal),
    enabled: Number.isInteger(collectionId) && collectionId > 0,
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  })
}
